import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuthStore } from "@/lib/auth.js";
import { toast } from "sonner";

export function LoginPage() {
  const nav = useNavigate();
  const login = useAuthStore((s) => s.login);
  const isAuthed = useAuthStore((s) => !!s.accessToken);
  const mustChange = useAuthStore((s) => s.mustChangePassword);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  if (isAuthed) return <Navigate to={mustChange ? "/change-password" : "/"} replace />;

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      await login(email, password);
      if (useAuthStore.getState().mustChangePassword) {
        toast.info("Por seguridad, debes actualizar tu contraseña");
        nav("/change-password", { replace: true });
      } else {
        toast.success("Bienvenido");
        nav("/", { replace: true });
      }
    } catch (err) {
      const msg = err instanceof Error ? err.message : "Error al iniciar sesión";
      setError(msg);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="h-full grid place-items-center bg-slate-50 dark:bg-slate-950">
      <form
        onSubmit={onSubmit}
        className="card w-[400px] p-8 space-y-5"
        aria-labelledby="login-title"
      >
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 rounded-md bg-brand-500 grid place-items-center text-white font-bold">
            iS
          </div>
          <div>
            <h1 id="login-title" className="text-lg font-semibold">
              Backoffice Gina
            </h1>
            <p className="text-xs text-slate-500">Accede con tu cuenta ISOFT</p>
          </div>
        </div>
        {error && (
          <div className="rounded-md bg-rose-50 border border-rose-200 text-rose-700 text-sm p-3">
            {error}
          </div>
        )}
        <div className="space-y-1">
          <label htmlFor="email" className="text-sm font-medium">Email</label>
          <input
            id="email"
            type="email"
            className="input"
            autoComplete="username"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="space-y-1">
          <label htmlFor="password" className="text-sm font-medium">Contraseña</label>
          <input
            id="password"
            type="password"
            className="input"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit" className="btn-primary w-full" disabled={loading}>
          {loading ? "Validando…" : "Ingresar"}
        </button>
        <p className="text-xs text-slate-500 text-center">
          ¿Problemas para acceder? Contacta a tu admin ISOFT.
        </p>
      </form>
    </div>
  );
}
